import { getBuildTimePwa } from './buildTimeConfig';

export const pwaConfig = {
  dashboardInstallBanner: getBuildTimePwa().installBanner,
  profileInstallSection: getBuildTimePwa().installProfile,
  iosInstallGuide: getBuildTimePwa().iosGuide,
};

export default pwaConfig;
